export default __webpack_public_path__ + "de.d800037b.png";